import { TSelect } from "../gui/Select/Select";
import RowsCache from "../jslibs/RowsCache"
import { type IFood } from "../shared/IFood";
import { TUnit } from "../shared/Recipes";
import FoodApi from "./FoodApi";

export default class Foods extends RowsCache<IFood> {
    private static _i:Foods
    private _options!:TSelect<number>[]
    
    static get i(){
        if (!this._i) this._i = (window as any).foods = new Foods("foods", 0)
        return this._i
    }
    fetch(): Promise<IFood[]> {
        return FoodApi.i.foods().then(all => all.sort((l,r) => l.name.localeCompare(r.name)))
    }
    key(row: IFood): string {
        return row._id.toString()
    }
    get options() {return this._options}
    id2option(id:number) { return this._options.find(o => o.id==id) || null}
    protected onCache(cache:IFood[]){
        super.onCache(cache)
        this._options = cache.map(food=>({id:food._id,text:food.name}))
    }
    name(id:number){
        return id ? this.fromCache(id.toString())?.name || id.toString() : ""
    }
    async setCup2grams(id:number,grams:number){
        return this.add(await FoodApi.i.setCup2grams(id, grams))
    }
    static cup2gram(food:IFood) { return food.units.find(unit => unit.name=="cup")?.grams || 0 }
    static amountInGrams(food:IFood, amount:number, unit:TUnit) {
        switch(unit) {
        case "mg":  return amount/1000
        case "µg":  return amount/1000000
        case "kg":  return amount*1000
        case "cup": return amount*Foods.cup2gram(food)
        case "tbsp":return amount*Foods.cup2gram(food)/16
        case "tsp": return amount*Foods.cup2gram(food)/16/3
        default:    return amount
        }        
    }
}
